import { hc, type ClientResponse } from "hono/client";
import type { ClientErrorStatusCode, ServerErrorStatusCode } from "hono/utils/http-status";
import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";
import type { AppType } from "@krut/server/app";

export const api = hc<AppType>("/api");
export const authClient = createAuthClient({ basePath: "/api/auth", plugins: [emailOTPClient()] });

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

/** The body type of the non-error members of a Hono response union. */
type OkBody<R> = R extends ClientResponse<infer T, infer S, string> ? ([S] extends [ClientErrorStatusCode | ServerErrorStatusCode] ? never : T) : never;

/** Resolves a typed Hono response to its JSON body, throwing ApiError on non-2xx. */
export async function unwrap<R extends ClientResponse<unknown, number, string>>(p: Promise<R>): Promise<OkBody<R>> {
  const res = await p;
  if (!res.ok) {
    let msg = res.statusText;
    try {
      const body = (await res.json()) as { error?: unknown };
      if (typeof body?.error === "string") msg = body.error;
      else if (body?.error) msg = "Please check the highlighted fields.";
    } catch {}
    throw new ApiError(res.status, msg);
  }
  return (await res.json()) as OkBody<R>;
}
